<template>
    <div class="t-lk-events t-lk-events-id">
        <div class="t-lk-container">
            <lk-breadcrumbs-cmp :breadcrumbs="breadcrumbs"></lk-breadcrumbs-cmp>

            <div v-if="info" v-animation:bottom.delay class="t-lk-promotions__row t-lk-container-mobile">
                <h1 class="t-lk-title t-lk-promotions__title">{{ info.title }}</h1>
                <a :href="info.link" target="_blank" class="t-btn-green">
                    <template v-if="!isMobile">
                        {{ $root.staticText.lk.photoDownload }}
                    </template>
                    <template v-else>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.99995 14.2012C3.44178 14.2012 3.79995 14.5593 3.79995 15.0012L3.79995 19.0012C3.79995 19.3194 3.92638 19.6247 4.15142 19.8497C4.37647 20.0747 4.68169 20.2012 4.99995 20.2012H19C19.3182 20.2012 19.6234 20.0747 19.8485 19.8497C20.0735 19.6247 20.2 19.3194 20.2 19.0012V15.0012C20.2 14.5593 20.5581 14.2012 21 14.2012C21.4418 14.2012 21.7999 14.5593 21.7999 15.0012V19.0012C21.7999 19.7438 21.5049 20.456 20.9798 20.9811C20.4547 21.5062 19.7426 21.8012 19 21.8012H4.99995C4.25734 21.8012 3.54515 21.5062 3.02005 20.9811C2.49495 20.456 2.19995 19.7438 2.19995 19.0012L2.19995 15.0012C2.19995 14.5593 2.55812 14.2012 2.99995 14.2012Z" fill="#00b0bd"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.43451 9.43353C6.74693 9.12111 7.25346 9.12111 7.56588 9.43353L12.0002 13.8678L16.4345 9.43353C16.7469 9.12111 17.2535 9.12111 17.5659 9.43353C17.8783 9.74595 17.8783 10.2525 17.5659 10.5649L12.5659 15.5649C12.2535 15.8773 11.7469 15.8773 11.4345 15.5649L6.43451 10.5649C6.12209 10.2525 6.12209 9.74595 6.43451 9.43353Z" fill="#00b0bd"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.20117C12.4418 2.20117 12.8 2.55934 12.8 3.00117L12.8 15.0012C12.8 15.443 12.4418 15.8012 12 15.8012C11.5581 15.8012 11.2 15.443 11.2 15.0012L11.2 3.00117C11.2 2.55934 11.5581 2.20117 12 2.20117Z" fill="#00b0bd"/>
                        </svg>
                    </template>
                </a>
            </div>

            <div v-if="info" class="t-lk-events-id-info">
                <div v-animation:bottom.delay class="t-lk-events-id-info__left">
                    <div class="t-lk-events-id-info__img">
                        <img v-if="info.img" :src="info.img" :alt="info.title">
                    </div>
                </div>
                <div v-animation:bottom.delay class="t-lk-events-id-info__right">
                    <div class="t-lk-events-id-info__row">
                        <div class="t-lk-events-id-info__category">{{ info.category }}</div>
                        <div class="t-lk-events-id-info__date">{{ info.date }}</div>
                    </div>
                    <div class="t-lk-events-id-info__title">{{ info.title }}</div>
                    <div class="t-lk-events-id-info__desc" v-html="info.description"></div>
                    <div v-if="info.img" class="t-lk-events-id-info__logo">
                        <img :src="info.imgLogo" alt="">
                    </div>
                </div>
            </div>

            <div class="t-lk-events-id__container">
                <div v-animation:bottom.delay v-for="item in photos" class="t-lk-events-id__item">
                    <img v-if="item.img" class="t-lk-events-id__img" :src="item.img" alt="photo">
                    <div
                        @click="modalType_certificatesOpen({
                            img: item.imgBig,
                            class: '_photos'
                        })"
                        class="t-lk-events-id__hover"
                    >
                        <div class="t-lk-events-id__svg">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.59999 4.80033C8.32695 4.80033 7.10606 5.30605 6.20588 6.20622C5.30571 7.1064 4.79999 8.32729 4.79999 9.60033C4.79999 10.8734 5.30571 12.0943 6.20588 12.9944C7.10606 13.8946 8.32695 14.4003 9.59999 14.4003C10.873 14.4003 12.0939 13.8946 12.9941 12.9944C13.8943 12.0943 14.4 10.8734 14.4 9.60033C14.4 8.32729 13.8943 7.1064 12.9941 6.20622C12.0939 5.30605 10.873 4.80033 9.59999 4.80033ZM2.39999 9.60033C2.39985 8.46718 2.66716 7.34999 3.1802 6.33962C3.69323 5.32926 4.4375 4.45425 5.35247 3.78576C6.26744 3.11728 7.32727 2.67419 8.44577 2.49253C9.56427 2.31088 10.7099 2.39579 11.7893 2.74035C12.8688 3.08492 13.8518 3.67942 14.6582 4.47549C15.4646 5.27156 16.0717 6.24673 16.4302 7.32169C16.7887 8.39665 16.8884 9.54104 16.7212 10.6618C16.554 11.7825 16.1246 12.848 15.468 13.7715L21.2484 19.5519C21.467 19.7783 21.5879 20.0814 21.5852 20.396C21.5825 20.7106 21.4563 21.0116 21.2338 21.2341C21.0113 21.4566 20.7103 21.5828 20.3957 21.5855C20.081 21.5883 19.7779 21.4673 19.5516 21.2487L13.7724 15.4695C12.6952 16.2355 11.428 16.6901 10.1096 16.7837C8.7912 16.8772 7.47248 16.6061 6.29795 15.9999C5.12343 15.3937 4.13842 14.476 3.45086 13.3472C2.76331 12.2183 2.39974 10.9221 2.39999 9.60033Z" fill="white"/>
                            </svg>
                        </div>
                        <a :href="item.imgBig" download class="t-lk-events-id__svg">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 16V17C4 17.7956 4.31607 18.5587 4.87868 19.1213C5.44129 19.6839 6.20435 20 7 20H17C17.7956 20 18.5587 19.6839 19.1213 19.1213C19.6839 18.5587 20 17.7956 20 17V16M16 12L12 16M12 16L8 12M12 16V4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>

            <load-more-cmp
                v-if="pagination"
                :pagination="pagination"
                :btn="$root.staticText.lk.loadMore"
                class="t-faq__more"
                :disabled-btn="disableLoadMore"
            >
            </load-more-cmp>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import lkBreadcrumbs from '@components/lk/lk-breadcrumbs/lk-breadcrumbs.vue';
    import LoadMore from '@components/ui-components/load-more/load-more';
    import { mapActions, mapState } from "vuex";
    import {router} from "@src/routes";

    export default {
        name: "lk-events-photos",
        data() {
            return {
                breadcrumbs: null,
                info: null,
                photos: [],
                pagination: null,
                disableLoadMore: false,
            }
        },
        components: {
            'lk-breadcrumbs-cmp': lkBreadcrumbs,
            'load-more-cmp': LoadMore,
        },
        computed: {
            ...mapState('mobile', ['isMobile', 'isTablet']),
        },
        methods: {
            ...mapActions('modal', ['modalType_certificatesOpen']),

            setData(data) {
                this.breadcrumbs = data.breadcrumbs;
                this.info = data.info;
                this.photos = data.photos;
                this.pagination = data.pagination;
            },
        },
        beforeRouteUpdate(to, from, next) {
            this.disableLoadMore = true;
            let url = process.env.NODE_ENV !== 'production' ?
                'lk/eventsIdPage.json' :
                to.path.substring(1).replace(router.history.base, '');

            Vue.http.get(url, {params: to.query}).then(
                (data) => {
                    next();
                    this.photos = this.photos.concat(data.data.photos);
                    this.pagination = data.data.pagination;
                    this.disableLoadMore = false;
                },
                (data) => {
                    this.disableLoadMore = false;
                    if (data.status === 403) {
                        next({name: 'E403'})
                    } else {
                        next({name: 'E404'})
                    }
                }
            );
        },
        beforeRouteEnter(to, from, next) {
            let url = process.env.NODE_ENV !== 'production' ?
                'lk/eventsIdPage.json' :
                to.path.substring(1).replace(router.history.base, '');

            Vue.http.get(url, {params: to.query}).then(
                (data) => {
                    next(vm => vm.setData(data.data));
                },
                (data) => {
                    if (data.status === 403) {
                        next({name: 'E403'})
                    } else {
                        next({name: 'E404'})
                    }
                }
            );
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/pages/lk/events/id/index.vue